import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/Home.css';
import { useUser } from './userContext';
import { tripAPI } from '../api/apiClient';
import AddTripPopup from './AddTripPopup';
import TripList from './TripList';
import useApi from './CustomHooks/useApi';
import LoadingOverlay from '../LoadingOverlay';
import ActionIcon from './Trips/Participants/ActionIcon';
import { homeMenuItems } from '../config/homeMenuItems';
import * as FaIcons from 'react-icons/fa';

const Home = () => {
  const { user } = useUser();
  const navigate = useNavigate(); 
  const [trips, setTrips] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  const { callApi, isLoading } = useApi();

  useEffect(() => {
    if (user) {
      callApi(() => tripAPI.getAllTripsWithBasicInfo())
        .then((response) => {
          if (response) setTrips(response);
        });
    }
  }, [user]);


  const handleActionClick = (item) => {
    if (item.path.startsWith('popup:')) {
      if (item.path === 'popup:add-trip') {
        setShowPopup(true);
      }
    } else {
      navigate(item.path);
    }
  };

  const renderMenu = () => {
    return filteredMenuItems.map((item, index) => {
      const Icon = FaIcons[item.icon];
      return (
        <ActionIcon
          key={index}
          icon={<Icon />}
          label={item.label}
          onClick={() => handleActionClick(item)}
        />
      );
    });
  };
  const filteredMenuItems = homeMenuItems.filter(item =>
    !item.roles || item.roles.some(role => user.roles.includes(role))
  );

  return (
    <>
      {isLoading && <LoadingOverlay text="Ładowanie danych..." />}
      
      <div className="home-container">
        <main className="home-actions">
          {renderMenu()}
        </main>

        <AddTripPopup show={showPopup} onClose={() => setShowPopup(false)} />
        <TripList trips={trips} />
      </div>
    </>
  );
};

export default Home;
